import { testDriveMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

export const tomNoPolicies: MockPersona = {
  key: "tomNoPolicies",
  name: "Tom NoPolicies",
  description: "🇨🇦 | No policies | No HDC | No alerts",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [],
        canada: [],
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "tom@nopolicies.com",
            firstName: "Tom",
            middleName: "",
            lastName: "NoPolicies",
            mailingAddress: {
              line1: "54 Erie Dr",
              line2: "",
              city: "Montreal",
              state: "QC",
              postalCode: "G1A 0A6",
              country: "CANADA",
            },
            preferredPhone: "5145551212",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000028",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: undefined,
    },
  },
};
